import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import slugify from "slugify";
import ResizeImageCanvas from "./ResizeImageCanvas.vue";
import { ImageTransform } from "../types";
import { useCanvases } from "../lib/canvases";
import { useDownload } from "../lib/download";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResizeImageSize',
  props: {
    title: null,
    width: null,
    height: null,
    span: null,
    fill: { type: Boolean },
    folder: null,
    image: null,
    transform: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  width: number;
  height: number;
  span?: number;
  fill?: boolean;
  folder: string;
  image?: HTMLImageElement;
  transform: ImageTransform;
}



const { downloadSingle } = useCanvases();
const { startDownload } = useDownload();

const filename = computed(() => {
  return `${slugify(props.title, { lower: true })}-${props.width}x${props.height}`;
});

const name = computed(() => {
  return `${props.folder}/${filename.value}`;
});

const px = (value: number | string) => `${value}px`;

const figureStyles = computed(() => {
  return {
    maxWidth: !props.fill ? `min(100%, ${px(props.width)}` : undefined,
    maxHeight: !props.fill ? px(props.height) : undefined,
    aspectRatio: `${props.width} / ${props.height}`
  };
});

return { __sfc: true,props, downloadSingle, startDownload, filename, name, px, figureStyles, ResizeImageCanvas }
}

})